<template>
  <el-scrollbar>
    <el-form :model="employeeData" label-width="150px">
      <el-row v-if="isEdit">
        <el-col :span="22">
          <el-form-item label="工号：" required>
            <el-input v-model="employeeData.employee_name" placeholder="工号" :disabled="isEdit" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="22">
          <el-form-item label="工号：" required>
            <el-select v-model="employeeData.employee_id" placeholder="姓名" filterable :disabled="isEdit" clearable>
              <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="毕业学校：" required>
            <el-input v-model="employeeData.school" placeholder="毕业学校" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="学历：" required>
            <el-select v-model="employeeData.education" placeholder="学历" clearable>
              <el-option v-for="item in educationLevelList" :key="item.id" :label="item.education_level_name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="院系：">
            <el-input v-model="employeeData.college" placeholder="院系" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="专业：" required>
            <el-input v-model="employeeData.major" placeholder="专业" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="入学日期：">
            <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.entry_date"
                            placeholder="选择日期" style="width: 100%" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="毕业日期：">
            <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.graduation_date"
                            placeholder="选择日期" style="width: 100%" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="备注：">
            <el-input v-model="employeeData.remark" placeholder="备注" :rows="2" type="textarea" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="照片：">
            <el-button type="primary" style="width: 100px;" plain @click="openCameraMain('school1')">毕业证书拍照</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="">
            <el-button type="primary" style="width: 100px;" plain @click="openCameraMain('school2')">学位证书拍照</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item>
            <FrameItem v-model="employeeData.by_certificate" :file-list="employeeData.by_certificate_obj" :item="uploadImgObj"></FrameItem>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item>
            <FrameItem v-model="employeeData.xw_certificate" :file-list="employeeData.xw_certificate_obj" :item="uploadImgObj"></FrameItem>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeEducation",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      educationLevelList: [],
      employeeList:[],
      loading: false,
      maxRetries: 3,
      retryCount: 0
    }
  },
  methods: {
    async loadEmployeeInfo() {
      let params = {id: this.parentData.id}
      let dbEmployee = await this.$http('employeeEducationService.getEmployeeEducation', params);
      if (dbEmployee) {
        this.isEdit = true;
        this.employeeData = dbEmployee;
      }
    },
    //获取员工列表
    async getEmployeeList() {
      this.employeeList = await this.$http('employeeArchivesService.getDepartmentAndEmpId');
    },
    //获取学历列表
    async getEducation() {
      let params = {modelId: "hr_education_level"}
      this.educationLevelList = await this.$http('employeeHRService.getAll',params);
    },
    async openCameraMain(photoType){
      this.dialogVisible = true;
      this.photoType = photoType;
      //await this.$http('photoService.setCamera');
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              switch (this.photoType){
                case "school1":
                  this.employeeData.by_certificate = data.avatar;
                  this.employeeData.by_certificate_obj = [data.file];
                  break;
                case "school2":
                  this.employeeData.xw_certificate = data.avatar;
                  this.employeeData.xw_certificate_obj = [data.file];
                  break;
              }
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    saveEmployeeInfo() {
      if (!this.employeeData.employee_id) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.school) {
        this.$message.error("请填写学校");
        return;
      }
      if (!this.employeeData.education) {
        this.$message.error("请选择学历");
        return;
      }
     /* if (!this.employeeData.college) {
        this.$message.error("请填写院系");
        return;
      }*/
      if (!this.employeeData.major) {
        this.$message.error("请填写专业");
        return;
      }
      /*if (!this.employeeData.entry_date) {
        this.$message.error("请填写入学日期");
        return;
      }
      if (!this.employeeData.graduation_date) {
        this.$message.error("请填写毕业日期");
        return;
      }*/
      this.loading = true;
      this.$http('employeeEducationService.add', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    //拍照
    async openCamera() {
      this.dialogVisible = true;
      //设置分辨率
      const data = {
        "mode": "0",
        "camidx": "1",
        "width": "1280",
        "height": "720"
      }
      try{
        const image = document.getElementById('view2');
        axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(response=>{
          console.log(response.data);
          if(response.data.code === "0"){
            image.src = '';
          }
          image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
        });
      }catch(error){
        this.$message.error("摄像头打开失败"+error.message);
      }
    },
    takePhoto() {
      let params = {
        "filepath": "base64",
        "camidx": "1",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response => {
        if (response) {
          let data = {photo: response.data};
          this.$http('photoService.takePhoto', data, false).then(data => {
            if (data) {
              this.employeeData.photo = data.avatar;
              this.employeeData.photo_obj = [data.file];
              this.dialogVisible = false;
              console.log(this.employeeData.photo_obj);
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    closeCamera() {
      let data = {"camidx": "1"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(() => {
        document.getElementById('view2').src = ''
      });
      this.dialogVisible = false;
    },
    async photoChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },
    clearProbationEndDate(){
      if (!this.employeeData.is_probation){
        this.employeeData.probation_end_date = ''
      }
    }
  },

  created() {
    this.loadEmployeeInfo();
    this.getEmployeeList();
    this.getEducation();
  },
}
</script>

<style scoped lang="less">

</style>